import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../../servicios/auth.service";
@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {

 public appName = "Hello Code";
 public permitido:boolean = false;
  constructor(public authSvc:AuthService) { }

  ngOnInit(): void {
    this.authSvc.verInfo().then(res=>
      {
        this.permitido = res;
      })
  }

  onLogout():void
  {
    this.authSvc.logOut();
  }

}
